import { ApiMananger } from "../rtkquery";
import {
  INVALIDATE_CLIENT,
  INVALIDATE_FOURNISSEURS,
  INVALIDATE_COMPTE_PAIEMENT,
  INVALIDATE_VENTES,
  INVALIDATE_DEPENSES,
  INVALIDATE_TRANSACTIONS,
  INVALIDATE_ECRITURE,
  INVALIDATE_LIVRE_JOURNAL,
  INVALIDATE_PRODUITS,
  INVALIDATE_CREANCES,
  INVALIDATE_DETTES,
} from "../invalidationTags";
import { ODOO_MIGRATION_IMPORT_API_ROUTE, ODOO_MIGRATION_LOGS_API_ROUTE } from "../../routes/api/endpoints";

// Tag dedie a l'historique des imports Odoo (pour rafraichir auto apres import)
const INVALIDATE_ODOO_LOGS = { type: "OdooMigrationLogs" };

const odooMigrationApi = ApiMananger.injectEndpoints({
  endpoints: (build) => ({
    importOdooData: build.mutation({
      query: (formData) => ({
        url: ODOO_MIGRATION_IMPORT_API_ROUTE,
        method: "POST",
        body: formData,
      }),
      invalidatesTags: [
        INVALIDATE_CLIENT,
        INVALIDATE_FOURNISSEURS,
        INVALIDATE_COMPTE_PAIEMENT,
        INVALIDATE_VENTES,
        INVALIDATE_DEPENSES,
        INVALIDATE_TRANSACTIONS,
        INVALIDATE_ECRITURE,
        INVALIDATE_LIVRE_JOURNAL,
        INVALIDATE_PRODUITS,
        INVALIDATE_CREANCES,
        INVALIDATE_DETTES,
        INVALIDATE_ODOO_LOGS,
      ],
    }),
    getOdooMigrationLogs: build.query({
      query: ({ dossier_id }) => ({
        url: `${ODOO_MIGRATION_LOGS_API_ROUTE}?dossier_id=${dossier_id}`,
        method: "GET",
      }),
      providesTags: [INVALIDATE_ODOO_LOGS],
    }),
  }),
});

export const {
  useImportOdooDataMutation,
  useGetOdooMigrationLogsQuery,
} = odooMigrationApi;
